import { Navigate, useParams } from 'react-router-dom';
import { pathwayPath } from '@/links';
import { useGetInventoryQuery } from '@/api/inventories';

type InventoryUrl = {
  inventoryId: string;
};

const InventoryDefault = () => {
  const params = useParams<InventoryUrl>();
  const inventoryId = Number(params.inventoryId);
  useGetInventoryQuery(inventoryId);
  return <Navigate to={pathwayPath(inventoryId)} replace />;
};

export { InventoryDefault };
